import { defineStore } from "pinia";
const baseUrl = useRuntimeConfig().public.apiBase;
import SoundPlayer from "@/utils/helpers/sound";
import type {
    Thirdparty,
    ThirdpartyStateProps,
} from "~/types/apps/EcommerceType";

export const useThirdpartyStore = defineStore({
    id: "thirdparty",
    state: (): ThirdpartyStateProps => ({
        thirdparties: [] as Thirdparty[],
        thirdparty: null,
        search: null,
        page: 1 as number,
        count: 0 as number,
        pageSize: 20 as number,
        pageCount: 1 as number,
    }),
    getters: {
        isThirdpartySelected(this: ThirdpartyStateProps) {
            return this.thirdparty && Object.keys(this.thirdparty).length > 0
                ? true
                : false;
        },
    },
    actions: {
        async fetchThirdparties(
            this: ThirdpartyStateProps,
            params: {
                page: number;
                page_size: number;
                search?: string;
                fields?: string;
            } = { page: this.page, page_size: this.pageSize },
        ) {
            if (this.search) {
                params["search"] = this.search.toUpperCase().trim();
            }
            params["fields"] =
                "id,identification_type_name,social_reason,identification_number"; // Para devlver solamente estos items

            try {
                const queryString = new URLSearchParams(
                    params as any,
                ).toString();
                let response = await fetchWrapper.get(
                    `${baseUrl}/api/v1/management/thirdparties/?${queryString}`,
                );
                this.thirdparties = response.results;
                this.count = response.count;
                this.pageCount = Math.round(
                    response.count / (params.page_size ?? 1),
                );
                return response.results;
            } catch (error) {
                console.log(error);
            }
        },
        async getThirdparty(id: number, option?: string | null) {
            try {
                const baseUrl = useRuntimeConfig().public.apiBase;
                const response = await fetchWrapper.get(
                    `${baseUrl}/api/v1/management/thirdparties/${id}/${option ? `${option}/` : ""}?random=${Math.random() * 10000}`,
                );
                this.thirdparty = response;
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async saveThirdparty(thirdparty: any) {
            try {
                const baseUrl = useRuntimeConfig().public.apiBase;
                const response = await fetchWrapper.post(
                    `${baseUrl}/api/v1/management/thirdparties/`,
                    thirdparty,
                );
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async editThirdparty(thirdparty: any) {
            try {
                const baseUrl = useRuntimeConfig().public.apiBase;
                const response = await fetchWrapper.patch(
                    `${baseUrl}/api/v1/management/thirdparties/${thirdparty.id}/`,
                    thirdparty,
                );
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async setSearch(search: string | null) {
            this.search = search;
        },
        async setThirdparty(thirdparty: any) {
            this.thirdparty = thirdparty;
            await SoundPlayer.playPop();
        },
    },
    persist: {
        storage: persistedState.localStorage,
    },
});
